import { render, staticRenderFns } from "./SceneMaterialPoint.vue?vue&type=template&id=25303a54&scoped=true&"
import script from "./SceneMaterialPoint.vue?vue&type=script&lang=js&"
export * from "./SceneMaterialPoint.vue?vue&type=script&lang=js&"
import style0 from "./SceneMaterialPoint.vue?vue&type=style&index=0&id=25303a54&prod&scoped=true&lang=css&"
import style1 from "./SceneMaterialPoint.vue?vue&type=style&index=1&id=25303a54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25303a54",
  null
  
)

export default component.exports